import Enum from 'enum';

export const AvatarSizes = new Enum([
    'smallish',
    'small',
    'medium',
    'medium_30',
    'large',
    'xLarge',
    'xxLarge',
]);

export const getFlowStatusPadding = (AvatarSize) => {
    const size = AvatarSize.key;

    switch (size) {
        case 'large':
            return '-1px';
        case 'xLarge':
            return 0;
        default:
            return '-2px';
    }
};

export const getFlowStatusProportionsFromSize = (AvatarSize) => {
    const size = AvatarSize.key;

    switch (size) {
        case 'xLarge':
            return 12;
        case 'small':
            return 6;
        case 'xxLarge':
            return 16;
        default:
            return 10;
    }
};

export const getAvtarSizeFromInt = (size) => {
    switch (size) {
        case 18:
            return AvatarSizes.small;
        case 36:
            return AvatarSizes.medium;
        case 48:
            return AvatarSizes.large;
        case 60:
            return AvatarSizes.xLarge;
        case 84:
            return AvatarSizes.xxLarge;
        default:
            return AvatarSizes.medium;
    }
};

/* The version makes the browser load a new picture. An upload or removal
 * sets the contact's lastUpdate, so the address is the same for every fetch
 * until the picture can have changed. The column can be empty; the caller
 * then decides with fallbackVersion, and without one the address stays plain. */
const avatarResourceWithVersion = (
    avatarResource,
    lastUpdate,
    fallbackVersion,
) => {
    const version = lastUpdate || fallbackVersion;
    return avatarResource && version != null
        ? `${avatarResource}?${encodeURIComponent(version)}`
        : avatarResource;
};

/* The contact with its avatar address versioned. Copies that must share an
 * address with the extension's contact go through this. */
export const withAvatarVersion = (contact, fallbackVersion) => {
    const avatarResource = contact?.get('avatarResource');
    if (!avatarResource) {
        return contact;
    }
    return contact.set(
        'avatarResource',
        avatarResourceWithVersion(
            avatarResource,
            contact.get('lastUpdate'),
            fallbackVersion,
        ),
    );
};
